// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require('../src/bootstrap.js')
require('../src/jquery.stickit.min.js')
require('../src/imagesloaded.pkgd.min.js')
require('../src/owl.carousel.js')
require('../src/jquery.mask.min.js')
require('../src/script.js')
require('../src/init.js')

import Rails from "@rails/ujs"
Rails.start()
